import React from 'react'
import SectionCollapse from '../../../../../section/SectionCollapse'
import DataGrid from '../../../../../table/DataGrid'

// FIXME: ACTUALZIAR CON WORKED EXAMPLES
const WorkedExamples = ({ workedExamples = [] }) => (
  <SectionCollapse title='Worked Examples'>
    <div className='relative h-screen-1/5'>
      <DataGrid
        id='worked-wxamples'
        showSetting={false}
        rows={workedExamples?.map((row, index) => {
          return {
            ...row,
            index: index + 1,
          }
        })}
        rowsPerPage={workedExamples?.length || 0}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
          { label: 'Worked examples', key: 'question', show: true, hide: false },
        ]}
        labelNoRows="You don't have any worked examples yet"
      />
    </div>
  </SectionCollapse>
)

export default WorkedExamples